
(function($, window, undefined) {

  var defaults = {
    selectorPrefix: 'wbsk-cart'
  };

  function wbskCart(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings);
    this.removeCtrl = `.${this.settings.selectorPrefix}__remove-from-cart`;
    this.qtySelector = `.${this.settings.selectorPrefix}__item-qty-selctor`;
    this.qtyCtrl = `.${this.settings.selectorPrefix}__item-qty`;
    this.wrapper = `.${this.settings.selectorPrefix}__wrapper`;
    this.cartTemplate = $(`.${this.settings.selectorPrefix}__cart-template`);
    this.count = $(`.${this.settings.selectorPrefix}__cart-count`);
    this.actions = `.${this.settings.selectorPrefix}__actions`;
    this.empty = `.${this.settings.selectorPrefix}__empty`;
   
    this.bind();
    this.udpate('init');
  };
  
  wbskCart.prototype = {
    
    bind: function() {
      var _this = this;
      //remove item
      $(document).on('click', this.removeCtrl, function(e) {
        e.preventDefault()
        _this.removeItem($(this))
      })
      //qty change event
      $(document).on('change', this.qtyCtrl, function(e) {
        e.preventDefault()
        _this.updateQty($(this))
      }.debounce(100))
      
      _this.cartTemplate.find(_this.qtySelector).qntSel()
    },

    addToCart:function(data){
      var _this = this;
      return new Promise(function(resolve,reject){
        _this.fetchHandler(`/cart/add.js?${data}`).then(function(result){
          return result.json()
        }).then(function(cart){
          _this.udpate('add').then(function(){
             if(_this.settings.onAdded && typeof _this.settings.onAdded == 'function'){
               _this.settings.onAdded(cart)
             }
            resolve(cart)
          })
        }).catch(function(error){
          console.log(error)
          reject(error)
        });
      })
    },
    
    udpate:function(type){
      var _this = this,
          url = _this.settings.cartFetchUrl;
      return new Promise(function(resolve,reject){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
        }
        _this.fetchHandler(url).then(function(result){
          return result.text();
        }).then(function(html){
          _this.cartTemplate.html(html)
          if(_this.settings.loadingClass && _this.settings.loadingClassElement){
            _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
          }
          _this.getCartJSON().then(function(cart){
            _this.as_json = cart
            //update the cart counter
	       _this.count.text(cart.item_count)
            //bind the qty selectors
            _this.cartTemplate.find(_this.qtySelector).qntSel()
            //fire the update event
            var event = new CustomEvent('update' , {bubbles: true});
            event.updateType = type
            event.cart = cart
            _this.element[0].dispatchEvent(event);
            resolve()
          })
        })
      })
    },
    
    updateQty:function($item){
      var _this = this,
          url = $item.attr('data-update') + $item.val();
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      _this.fetchHandler(url).then(function(res){
        _this.udpate()
      })
    },
    
    removeItem:function($item){
      var _this = this;
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
      }
      _this.fetchHandler($item.attr('href')).then(function(res){
        _this.udpate('remove')
      })
      
    },
    
    fetchHandler:function(url){
      return new Promise(function(resolve,reject){
        fetch(url).then(function(result){
          resolve(result)
        }).catch(function(error){
          reject(error)
        })
      })
    },
    
    getCartJSON:function(){
      var _this = this
      return new Promise(function(resolve,reject){
        fetch('/cart.js').then(function(result){
          return result.json()
        }).then(function(data){
          resolve(data)
        });
      })
    }
  };

  $.fn.wbskCart = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskCart', new wbskCart(this, settings))
    })
  }

}(jQuery, window));

